module.exports = __webpack_public_path__ + "static/Product_AndroidTV-37ab871ccd9c032e87347d87acbb93d9.png";